import { render } from "./Searchbar.vue?vue&type=template&id=1624542f"
import script from "./Searchbar.vue?vue&type=script&lang=js"
export * from "./Searchbar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__